import getConfig from 'next/config';
import Cookie from 'js-cookie';

export const isInCohort = ({ serverSideCohort = '', storedCohort }) => {
  const { publicRuntimeConfig } = getConfig();
  const cohort = serverSideCohort || Cookie.get(storedCohort);

  const threshold = publicRuntimeConfig[storedCohort];

  if (typeof cohort === 'undefined') {
    return false;
  }

  return Number(cohort) <= Number(threshold);
};
